var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from "react";
import { AccordionContext } from "./Accordion";
import { AccordionItemContext } from "./AccordionItem";
import { styled, css } from "../styling";
const animationDuration = 0.3;
const Content = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: ${(props) => (props.active ? "visible" : "hidden")};
`;
const ContentWrapper = styled.div `
  position: relative;
  display: flex;
  min-height: 0;
  ${(props) => props.active
    ? css `
          flex: 1;
          min-height: 0;
          max-height: 100vh;
        `
    : css `
          flex: 0;
          overflow: hidden;
          max-height: 0;
        `}
  transition: ${animationDuration}s ease-out;
  transition-property: max-height, flex;
`;
export const AccordionItemBody = (props) => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    const { activeIndex } = useContext(AccordionContext);
    const index = useContext(AccordionItemContext);
    const active = activeIndex === index;
    return (React.createElement(ContentWrapper, Object.assign({}, rest, { className: className, active: active }),
        React.createElement(Content, { active: active }, children)));
};
//# sourceMappingURL=AccordionItemBody.js.map